import React from 'react';
import { func, bool } from 'prop-types';
import styled from 'styled-components';
import { Switch } from '@material-ui/core';

const StyledSwitch = ({ checked, onChangeHandler }) => {
  const CustomSwitch = styled(Switch)`
    .MuiSwitch-thumb {
      color: ${({ theme }) => theme.colors.default};
      border: 1px solid ${({ theme }) => theme.colors.secondary};
    }

    .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track {
      opacity: 1;
      background-color: ${({ theme }) => theme.colors.secondary};
    }

    .MuiSwitch-colorPrimary.Mui-checked {
      color: ${({ theme }) => theme.colors.primaryWhite};
    }
  `;

  return (
    <CustomSwitch
      checked={checked}
      size="small"
      onChange={() => onChangeHandler(!checked)}
      color="primary"
    />
  );
};

StyledSwitch.propTypes = {
  onChangeHandler: func,
  checked: bool,
};

export default StyledSwitch;
